import { render, staticRenderFns } from "./Sunflower.vue?vue&type=template&id=6bae4ffe&scoped=true&"
import script from "./Sunflower.vue?vue&type=script&lang=js&"
export * from "./Sunflower.vue?vue&type=script&lang=js&"
import style0 from "./Sunflower.vue?vue&type=style&index=0&id=6bae4ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae4ffe",
  null
  
)

export default component.exports